import moment from "moment";

/** Default preset: Last 30 Days (IDMS DateFormula value). */
export const DEFAULT_DYNAMIC_DATE_RANGE = "115";

/** Past / present presets only — for Search Deals received_date filter (IDMS-style). */
export const DEAL_SEARCH_DYNAMIC_DATE_OPTIONS = [
  { value: "115", label: "Last 30 Days" },
  { value: "5", label: "Last 7 Days" },
  { value: "47", label: "Last Month" },
  { value: "48", label: "Last Month to Date" },
  { value: "49", label: "Last Quarter" },
  { value: "50", label: "Last Quarter to Date" },
  { value: "41", label: "Last Week" },
  { value: "46", label: "Last Week to Date" },
  { value: "51", label: "Last Year" },
  { value: "52", label: "Last Year to Date" },
  { value: "145", label: "Prior to Today" },
  { value: "40", label: "This Month" },
  { value: "33", label: "This Month to Date" },
  { value: "42", label: "This Quarter" },
  { value: "43", label: "This Quarter to Date" },
  { value: "38", label: "This Week" },
  { value: "39", label: "This Week to Date" },
  { value: "44", label: "This Year" },
  { value: "45", label: "This Year to Date" },
  { value: "34", label: "Today" },
  { value: "35", label: "Yesterday" },
];

const toYmd = (m) => m.format("YYYY-MM-DD");

const quarterStart = (m) => m.clone().startOf("quarter");
const quarterEnd = (m) => m.clone().endOf("quarter");

/**
 * Resolve an IDMS-style dynamic date formula code to { startDate, endDate } (YYYY-MM-DD).
 */
export const resolveDynamicDateRange = (code, referenceDate = new Date()) => {
  const today = moment(referenceDate).startOf("day");
  let start = today.clone();
  let end = today.clone();

  switch (String(code)) {
    case "34": // Today
      break;
    case "35": // Yesterday
      start = today.clone().subtract(1, "day");
      end = start.clone();
      break;
    case "5": // Last 7 Days
      start = today.clone().subtract(7, "days");
      break;
    case "115": // Last 30 Days
      start = today.clone().subtract(30, "days");
      break;
    case "38": // This Week (Sun–Sat)
      start = today.clone().startOf("week");
      end = today.clone().endOf("week");
      break;
    case "39": // This Week to Date
      start = today.clone().startOf("week");
      break;
    case "41": // Last Week
      start = today.clone().subtract(1, "week").startOf("week");
      end = today.clone().subtract(1, "week").endOf("week");
      break;
    case "46": // Last Week to Date
      start = today.clone().subtract(1, "week").startOf("week");
      break;
    case "40": // This Month
      start = today.clone().startOf("month");
      end = today.clone().endOf("month");
      break;
    case "33": // This Month to Date
      start = today.clone().startOf("month");
      break;
    case "47": // Last Month
      start = today.clone().subtract(1, "month").startOf("month");
      end = today.clone().subtract(1, "month").endOf("month");
      break;
    case "48": // Last Month to Date
      start = today.clone().subtract(1, "month").startOf("month");
      break;
    case "42": // This Quarter
      start = quarterStart(today);
      end = quarterEnd(today);
      break;
    case "43": // This Quarter to Date
      start = quarterStart(today);
      break;
    case "49": // Last Quarter
      start = quarterStart(today.clone().subtract(1, "quarter"));
      end = quarterEnd(today.clone().subtract(1, "quarter"));
      break;
    case "50": // Last Quarter to Date
      start = quarterStart(today.clone().subtract(1, "quarter"));
      break;
    case "44": // This Year
      start = today.clone().startOf("year");
      end = today.clone().endOf("year");
      break;
    case "45": // This Year to Date
      start = today.clone().startOf("year");
      break;
    case "51": // Last Year
      start = today.clone().subtract(1, "year").startOf("year");
      end = today.clone().subtract(1, "year").endOf("year");
      break;
    case "52": // Last Year to Date
      start = today.clone().subtract(1, "year").startOf("year");
      break;
    case "145": // Prior to Today
      start = moment("1900-01-01");
      end = today.clone().subtract(1, "day");
      break;
    default:
      start = today.clone().subtract(30, "days");
      break;
  }

  return {
    startDate: toYmd(start),
    endDate: toYmd(end),
  };
};
